import React from 'react';
import { useForm } from 'components/form/Form';
import { classNames } from 'libs/react';
import { useValue } from 'components/form/hook/useValue';
import { useIdent } from 'libs/react';
import { useIf } from 'libs/react';
import { useState } from 'libs/react';
import { useWatch } from 'libs/react';
import { useRef } from 'libs/react';
import { useEffect } from 'libs/react';
import { FormFieldError } from 'components/form/FormFieldError';
import { FormFieldInfos } from 'components/form/FormFieldInfos';
import { FormFieldLabel } from 'components/form/FormFieldLabel';
import { Icon } from 'components/Icon';
import { Text } from 'components/Text';
import { Button } from 'components/Button';
import IntlTelInput from 'intl-tel-input/react';
import './FormPhone.scss';
/**
 * @component FormPhone
 * @since 1.0.0
 */
export function FormPhone(props) {
    let { name, size, style, picto, badge, label, tooltip, infos, error, required, optional, disabled, clearable, prefix, suffix } = Object.assign({ size: 'medium', name: '', style: 'normal', picto: 'phone' }, props);
    const form = useForm();
    const [ident] = useIdent('form-input');
    const [value, setValue] = useValue(name, props.value, props.defaultValue || '');
    const [focused, setFocused] = useState(false);
    const inputRef = useRef(null);
    const containerRef = useRef(null);
    /**
     * @function onClear
     * @since 1.0.0
     * @hidden
     */
    function onClear() {
        setValue('');
    }
    /**
     * @function onBlur
     * @since 1.0.0
     * @hidden
     */
    function onBlur() {
        setFocused(false);
    }
    /**
     * @function onFocus
     * @since 1.0.0
     * @hidden
     */
    function onFocus() {
        setFocused(true);
    }
    /**
     * @function onChange
     * @since 1.0.0
     * @hidden
     */
    function onChange(value) {
        setValue(value);
    }
    useIf(focused, props.onFocus, props.onBlur);
    useWatch(() => {
        if (props.onChange) {
            props.onChange(value);
        }
    }, [value]);
    // Set required attribute on the underlying input element
    useEffect(() => {
        if (containerRef.current && required) {
            // Find the input element created by IntlTelInput
            const input = containerRef.current.querySelector('input[type="tel"]');
            if (input) {
                input.setAttribute('required', 'required');
                input.setAttribute('name', name || '');
                // Also set aria-required for accessibility
                input.setAttribute('aria-required', 'true');
            }
        }
        else if (containerRef.current && !required) {
            // Remove required if it was set before
            const input = containerRef.current.querySelector('input[type="tel"]');
            if (input) {
                input.removeAttribute('required');
                input.removeAttribute('aria-required');
            }
        }
    }, [required, name]);
    // Cleanup effect to destroy IntlTelInput instance on unmount
    useEffect(() => {
        return () => {
            var _a, _b;
            // Cleanup IntlTelInput instance when component unmounts
            if (inputRef.current) {
                try {
                    (_b = (_a = inputRef.current).destroy) === null || _b === void 0 ? void 0 : _b.call(_a);
                }
                catch (error) {
                    // Silently catch any errors during cleanup
                }
            }
        };
    }, []);
    if (error == null) {
        error = form.getError(name);
    }
    const className = classNames('form-phone', 'form-phone--' + size, 'form-phone--' + style, { 'form-phone--is-required': required }, { 'form-phone--is-optional': optional }, { 'form-phone--is-disabled': disabled }, { 'form-phone--is-focused': focused }, { 'form-phone--has-label': label !== '' }, { 'form-phone--has-value': value !== '' }, { 'form-phone--has-picto': picto }, { 'form-phone--has-badge': badge }, { 'form-phone--has-error': error }, props.className);
    return (React.createElement("div", { className: className },
        React.createElement("div", { className: "form-phone-field" },
            React.createElement("div", { className: "form-phone-field-head" },
                label && (React.createElement(FormFieldLabel, { className: "form-phone-label", style: style, label: label, ident: ident, tooltip: tooltip, required: required, optional: optional, disabled: disabled })),
                infos && (React.createElement(FormFieldInfos, { className: "form-phone-infos", style: style, infos: infos }))),
            React.createElement("div", { className: "form-phone-field-body", ref: containerRef },
                prefix && React.createElement("div", { className: "form-phone-prefix" }, prefix),
                React.createElement(IntlTelInput, { ref: inputRef, initialValue: value, onChangeNumber: onChange, onBlur: onBlur, onFocus: onFocus, initOptions: {
                        initialCountry: 'ca',
                        formatOnDisplay: true,
                        autoPlaceholder: 'aggressive',
                        loadUtils: () => import('intl-tel-input/build/js/utils')
                    } }),
                picto && React.createElement(Icon, { className: "form-phone-picto", value: picto }),
                value && clearable && (React.createElement(Button, { className: "form-input-clear", style: "picto", picto: "fad circle-xmark", onPress: onClear })),
                badge && React.createElement(Text, { className: "form-phone-badge", value: badge }),
                suffix && React.createElement("div", { className: "form-phone-suffix" }, suffix))),
        React.createElement(FormFieldError, { error: error })));
}
